import axios from 'axios'
import qs from 'qs'
// import Mock from 'mockjs';
const REQ_FAIL = '服务端异常'
const TIMEOUT = '请求超时'

// 设置 7 秒超时
const timeout = reject =>
    setTimeout(() => reject(TIMEOUT), 7e3);

export default {
    /**
     * 获取工单列表
     */
    getWorkOrder(param = {}) {
        const url = '/dashboard/workorder/getAllWorkOrder'
        return new Promise((resolve, reject) => {
            axios.get(url, {
                params: param
            }).then(resp => resolve(resp.data))
                .catch(e => reject(REQ_FAIL))
            timeout(reject)
        })
    },

    /**
     * 获取工单详情
     * @param {string} id 工单id
     */
    getWorkOrderDetail(param = {}) {
        const url = '/dashboard/workorder/getWorkOrderDetail'
        return new Promise((resolve, reject) => {
            axios.get(url, {
                params: param
            }).then(resp => resolve(resp.data))
                .catch(e => reject(REQ_FAIL))
            timeout(reject)
        })
    },

    /**
     * 提交工单评价
     * @param {object} param 工单信息表单
     */
    submitRate(param = {}) {
        const url = '/dashboard/workorder/evaluate'
        return new Promise((resolve, reject) => {
            axios.get(url, {
                params: param
            })
                .then(resp => resolve(resp.data))
                .catch(e => reject(REQ_FAIL))
            timeout(reject)
        })
    },


    /**
     * 提交工单评价
     * @param {object} param 工单信息表单
     */
    submitAppend(param = {}) {
        const url = '/dashboard/workorder/submitContent'
        return new Promise((resolve, reject) => {
            axios.get(url, {
                params: param
            })
                .then(resp => resolve(resp.data))
                .catch(e => reject(REQ_FAIL))
            timeout(reject)
        })
    }

}



// WEBPACK FOOTER //
// ./app/api/my-work-order.js